import React, { useState, useEffect } from 'react';

const THEMES = [
  { id: 'classic', label: 'Classic', icon: '🎨', desc: 'Original theme' },
  { id: 'light',   label: 'Light',   icon: '☀️', desc: 'Shadcn light' },
  { id: 'dark',    label: 'Dark',    icon: '🌙', desc: 'Shadcn dark' },
];

const applyTheme = (id) => {
  const html = document.documentElement;
  html.classList.remove('yk-shadcn', 'yk-dark');
  if (id === 'light') html.classList.add('yk-shadcn');
  if (id === 'dark')  html.classList.add('yk-shadcn', 'yk-dark');
};

const ThemeToggle = () => {
  const [theme, setTheme] = useState(() => localStorage.getItem('yk-theme') || 'light');
  const [open, setOpen]   = useState(false);

  useEffect(() => {
    applyTheme(theme);
    localStorage.setItem('yk-theme', theme);
  }, [theme]);

  useEffect(() => {
    if (!open) return;
    const close = (e) => { if (!e.target.closest('.yk-tt-root')) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, [open]);

  const current = THEMES.find(t => t.id === theme);

  return (
    <div className="yk-tt-root" style={styles.root}>

      {open && (
        <div style={styles.panel}>
          <div style={styles.panelLabel}>Theme</div>
          {THEMES.map(t => (
            <button
              key={t.id}
              onClick={() => { setTheme(t.id); setOpen(false); }}
              style={{
                ...styles.option,
                background: theme === t.id ? 'var(--yk-accent,#eff6ff)' : 'transparent',
                color:      theme === t.id ? 'var(--yk-primary,#3b82f6)' : 'var(--yk-text,#0f172a)',
                fontWeight: theme === t.id ? 700 : 500,
              }}
            >
              <span style={{ fontSize: '1rem' }}>{t.icon}</span>
              <span style={{ flex: 1, textAlign: 'left' }}>{t.label}</span>
              <span style={{ fontSize: '0.65rem', color: 'var(--yk-text-muted,#64748b)' }}>{t.desc}</span>
              {theme === t.id && <span style={{ fontSize: '0.7rem', marginLeft: '0.25rem' }}>✓</span>}
            </button>
          ))}
        </div>
      )}

      <button
        onClick={() => setOpen(o => !o)}
        title={`Theme: ${current.label} — click to switch`}
        style={styles.fab}
      >
        {current.icon}
      </button>
    </div>
  );
};

const styles = {
  root: {
    position: 'fixed',
    bottom: '1.5rem',
    right:  '1.5rem',
    zIndex: 9999,
    fontFamily: 'inherit',
  },
  panel: {
    position:     'absolute',
    bottom:       '3.25rem',
    right:        0,
    background:   'var(--yk-surface,#ffffff)',
    border:       '1px solid var(--yk-border,#e2e8f0)',
    borderRadius: '0.75rem',
    boxShadow:    '0 10px 30px rgba(0,0,0,0.15)',
    padding:      '0.4rem',
    minWidth:     '200px',
    display:      'flex',
    flexDirection:'column',
    gap:          '2px',
  },
  panelLabel: {
    fontSize:      '0.65rem',
    fontWeight:    700,
    color:         'var(--yk-text-muted,#94a3b8)',
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    padding:       '0.3rem 0.6rem 0.4rem',
  },
  option: {
    display:       'flex',
    alignItems:    'center',
    gap:           '0.5rem',
    padding:       '0.5rem 0.65rem',
    borderRadius:  '0.5rem',
    border:        'none',
    fontSize:      '0.875rem',
    cursor:        'pointer',
    width:         '100%',
    transition:    'background 0.15s',
  },
  fab: {
    width:        '2.75rem',
    height:       '2.75rem',
    borderRadius: '50%',
    border:       '1px solid var(--yk-border,#e2e8f0)',
    background:   'var(--yk-surface,#ffffff)',
    boxShadow:    '0 4px 14px rgba(0,0,0,0.12)',
    cursor:       'pointer',
    fontSize:     '1.15rem',
    display:      'flex',
    alignItems:   'center',
    justifyContent:'center',
    transition:   'transform 0.2s, box-shadow 0.2s',
  },
};

export default ThemeToggle;
